(function() {
  var FOCUSABLE_SELECTOR =
    'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, ' +
    '[tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  var needmodal = document.getElementById('needhelp');
  var howtomodal = document.getElementById('howtomeasure');

  var needbtn = document.getElementById('needhelpbtn');
  var howtobtn = document.getElementById('howmeasurebtn');

  var needspan = document.getElementsByClassName('custom-close')[0];
  var howtospan = document.getElementsByClassName('how-custom-close')[0];

  var activeModal = null;
  var lastFocused = null;

  function getFocusable(modal) {
    var nodes = modal.querySelectorAll(FOCUSABLE_SELECTOR);
    return Array.prototype.filter.call(nodes, function(el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function sgOpenModal(modal) {
    activeModal = modal;
    lastFocused = document.activeElement;
    modal.style.display = 'block';

    var focusable = getFocusable(modal);
    if (focusable.length) {
      focusable[0].focus();
    } else {
      modal.setAttribute('tabindex', '-1');
      modal.focus();
    }
  }

  function sgCloseModal(modal) {
    modal.style.display = 'none';
    if (activeModal === modal) {
      activeModal = null;
    }
    if (lastFocused && lastFocused.focus) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  function sgTrapFocus(event) {
    if (!activeModal) return;
    if (event.key !== 'Tab' && event.keyCode !== 9) return;

    var focusable = getFocusable(activeModal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else if (document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', sgTrapFocus);

  needbtn.onclick = function(event) {
    event.preventDefault()
    sgOpenModal(needmodal);
  };
  howtobtn.onclick = function(event) {
    event.preventDefault()
    sgOpenModal(howtomodal);
  };

  needspan.onclick = function() {
    sgCloseModal(needmodal);
  };
  howtospan.onclick = function() {
    sgCloseModal(howtomodal);
  };

  //When the user clicks anywhere outside of the modal, close it
  window.addEventListener('click', function(event) {
    if (event.target == howtomodal) {
      sgCloseModal(howtomodal);
    }
    if (event.target == needmodal) {
      sgCloseModal(needmodal);
    }
  });
})();
